export default {
  title: 'אסמכתאות',
  form: {
    labels: {
      paymentProofNumber: 'מספר אסמכתא',
      value: 'סכום',
      paymentDate: 'תאריך הפקדה',
      agents: 'סוכנים',
      comments: 'הערות',
    },
  },
  table: {
    titles: {
      paymentProofNumber: 'מספר אסמכתא',
      value: 'סכום',
      paymentDate: 'תאריך הפקדה',
      associatedAgents: 'סוכנים ',
      createdAt: 'תאריך טעינה',
    },
  },
};
